// import { renderRequiredRule } from "@/utils/renderRulesForm";

export default (applicationCargoPickup) => ({
  deliveryToTheAddress: false,
  addressConsignee: [
    {
      validator: (rule, value, callback) => {
        if (applicationCargoPickup.deliveryToTheAddress && value === "") {
          callback(new Error("Пожалуйста введите адрес"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
});
